module.exports = __webpack_public_path__ + "static/media/pulsidS.3ea4ba58.jpg";